// reduces the subset of countries depending on whether the user specified a white/blacklist, and lists priority
// countries first
export const filterCountries = (countries, priorityCountries, whitelist, blacklist) => {
	const countriesListedFirst: any = [];
	let filteredCountries = countries;

	if (whitelist.length > 0) {
		filteredCountries = countries.filter(({ countryShortCode }) => whitelist.indexOf(countryShortCode) > -1);
	} else if (blacklist.length > 0) {
		filteredCountries = countries.filter(({ countryShortCode }) => blacklist.indexOf(countryShortCode) === -1);
	}

	if (priorityCountries.length > 0) {

		// ensure the countries are added in the order in which they are specified by the user
		priorityCountries.forEach((slug) => {
			const result = filteredCountries.find(({ countryShortCode }) => countryShortCode === slug);
			if (result) {
				countriesListedFirst.push(result);
			}
		});

		filteredCountries = filteredCountries.filter(({ countryShortCode }) => priorityCountries.indexOf(countryShortCode) === -1);
	}

	return countriesListedFirst.length ? [...countriesListedFirst, ...filteredCountries] : filteredCountries;
};
